/**
 * 🛰️ src\registered\site-admin\SEC_03_Usermanagement\Validations\SEC_03_AssignmentValidation.js
 * 
 * Shared logic for validating Division/Role relationships.
 */
export const SEC_03_AssignmentValidation = (divisionId, roleId, existingMatrix = []) => {
  if (!divisionId || !roleId) {
    return { isValid: false, message: "Both Division and Role must be selected." };
  }

  // Check if this specific combination already exists for this user
  const isDuplicate = existingMatrix.some(
    (item) => item.ResourceId === divisionId && item.RoleId === roleId
  );

  if (isDuplicate) {
    return { isValid: false, message: "This assignment already exists." };
  }

  return { isValid: true, message: "Validation Successful" };
};